import { Dropdown, Nav } from "react-bootstrap";
import { GAME_NAME } from "../../common/constants.ts";
import { GAME_LINKS } from "./GameLinks.tsx";

export const GameSwitcher = () => {
	return (
		<Dropdown as={Nav.Item} align="end">
			<Dropdown.Toggle as={Nav.Link} id="game-switcher">
				<span className="d-none d-md-inline">Switch game</span>
				<span className="d-md-none" title="Switch game">
					Games
				</span>
			</Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Header>Switch game</Dropdown.Header>
				{GAME_LINKS.map((game) => (
					<Dropdown.Item
						active={game.name === GAME_NAME}
						href={game.url}
						key={game.name}
						rel="noopener"
					>
						{game.name}
						{game.name === GAME_NAME ? " (current)" : ""}
					</Dropdown.Item>
				))}
			</Dropdown.Menu>
		</Dropdown>
	);
};
